import axios from 'axios';
import { app } from '../../config';

const BASE = `${app.URL}/api/v1/web/meeting`;
// const BASE = `http://localhost:3001/api/v1/web/meeting`;

/* The API wraps every reply in apiResponse() — { result: { success, code, msg } }
   — and sends failures with a non-2xx status, so axios throws. The readable text
   lives in result.msg, not message. */
const errMessage = (e) =>
  e?.response?.data?.result?.msg || e?.response?.data?.message || e.message;

/* ── Every host's events (admin panel)  GET /admin/list ──
   The per-host GET /user/:patientId that the web portal uses is scoped to one
   customer; this one spans all of them and carries feedbackCount per event. */
export async function getAllMeetingsAdmin({ limit = 10, offset = 0, search = '', status = '' } = {}) {
  try {
    const params = new URLSearchParams({ limit, offset });
    if (search) params.set('search', search);
    if (status) params.set('status', status);

    const response = await axios.get(`${BASE}/admin/list?${params.toString()}`);
    const result = response?.data?.result;
    return {
      success: !!result?.success,
      data: result?.data?.data || [],
      count: result?.data?.count || 0,
      message: result?.msg,
    };
  } catch (e) {
    console.error('getAllMeetingsAdmin', e);
    return { success: false, data: [], count: 0, message: errMessage(e) };
  }
}

/* ── Feedback for one meeting  GET /:id/feedback?patientId= ──
   Unchanged host-only endpoint reused as-is: it authorises by comparing
   patientId against the meeting's hostId, and the admin list hands us that
   hostId with every event. */
export async function getMeetingFeedbackAdmin(meetingId, hostId) {
  try {
    const response = await axios.get(`${BASE}/${meetingId}/feedback?patientId=${hostId}`);
    const result = response?.data?.result;
    return {
      success: !!result?.success,
      feedback: result?.data?.feedback || [],
      message: result?.msg,
    };
  } catch (e) {
    console.error('getMeetingFeedbackAdmin', e);
    return { success: false, feedback: [], message: errMessage(e) };
  }
}
